export const buttonGroupFic = (theme) => {
  return {
    "&.MuiButtonGroup-root": {
      borderRadius: 4,
      boxShadow: "none"
    },
    "&.MuiButtonGroup-root .MuiButton-root.MuiButton-contained": {
      lineHeight: "normal",
      border: "1px solid " + theme.palette.primary.borderDefault,
      minWidth: 36,
      minHeight: 32,
      height: 32,
      padding: "6px 16px",
      background: "#ffffff",
      color: theme.palette.primary.textSubduedColor,
      textShadow: "none",
      fontSize: 14,
      ":hover": {
        background: "#ffffff",
        color: theme.palette.primary.textTitleColor,
        fontWeight: 500
      },
      ":first-of-type": {
        borderRadius: "4px 0px 0px 4px",
        minHeight: 32,
        height: 32,
        background: "#ffffff",
        color: theme.palette.primary.textSubduedColor,
        textShadow: "none",
        fontSize: 14,
        ":hover": {
          background: "#ffffff",
          color: theme.palette.primary.textTitleColor
        }
      },
      ":last-child": {
        borderRadius: "0px 4px 4px 0px"
      },
      ":not(:last-child)": {
        border: "1px solid " + theme.palette.primary.borderDefault
      }
    },
    "&.MuiButtonGroup-root .MuiButton-root.MuiButton-outlined": {
      lineHeight: "normal",
      padding: "5px 16px",
      minWidth: 36,
      border: "1px solid #008BCC",
      height: 32,
      minHeight: 32,
      background: "#ffffff",
      color: theme.palette.primary.interactiveDefault,
      fontSize: 14,
      fontWeight: 500,
      ":first-of-type": {
        borderRadius: "4px 0px 0px 4px"
      },
      ":last-child": {
        borderRadius: "0px 4px 4px 0px"
      }
    },
    "&.MuiButtonGroup-root .MuiButton-root svg": {
      width: 18,
      height: 16
    }
  };
};
